module.exports = __webpack_public_path__ + "static/media/LOGO-MIA.1c23eeed.png";